import { render, staticRenderFns } from "./MySelectTypeOfMarket.vue?vue&type=template&id=5dd4b808&"
import script from "./MySelectTypeOfMarket.vue?vue&type=script&lang=js&"
export * from "./MySelectTypeOfMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports